export const AUTH_CONFIG = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientId: process.env.REACT_APP_AUTH0_CLIENTID,
  callbackUrl: process.env.REACT_APP_AUTH0_CALLBACK_URL
};
